<template>
  <div>
    <section class="header" v-if="showHeaded">
      <header1></header1>
    </section>
    <div>
      <iframe
        id="dzIframe"
        src="https://241.scsjb.cn?from=wap"
        frameborder="0"
        style="width: 100%; height: 100vh"
      ></iframe>
    </div>
  </div>
</template>
<script>
import header1 from "@/components/header4";
export default {
  components: {
    header1,
  },
  data() {
    return {
      iframeRoute: "",
    };
  },
  computed: {
    showHeaded() {
      return (
        this.iframeRoute.indexOf("news") == -1
        // this.iframeRoute.indexOf("userContent") == -1
      );
    },
  },
  mounted() {
    let that = this;
    window.addEventListener("message", function (e) {
      if (e.origin == "https://241.scsjb.cn") {
        that.iframeRoute = e.data.route;
        localStorage.setItem("iframeRoute", e.data.route);
      }
    });
  },
  beforeDestroy() {
    localStorage.removeItem("iframeRoute");
  },
};
</script>
